export function getDecryptWorker(): Worker {
  return new Worker(new URL('./decrypt-encryption-key.ts', import.meta.url), { type: 'module' });
}

export function getGenerateKeysWorker(): Worker {
  return new Worker(new URL('./generate-keys-worker.ts', import.meta.url), { type: 'module' });
}
